export const ONLY_DIGITS_REGEXP = /^\d+$/;
